import { Tooltip } from '@spotnana/blocks/src/Tooltip';
import { ClickableLabel, type TClickableLabelProps } from '@spotnana/blocks/src/Label/Label';
import { useTranslation } from 'react-i18next';
import React from 'react';

type OutOfPolicyLabelProps = Omit<TClickableLabelProps, 'label'> & {
  /** Tooltip to be displayed on the Label */
  tooltip?: React.ReactNode;
  /** custom label to be displayed on the Label */
  label?: string;
};

/**
 * @deprecated Do use PolicyViolationLabelWithModal
 *
 * Renders OOP Label with tooltip
 * @param props
 * @returns
 */
export function OutOfPolicyLabel(props: OutOfPolicyLabelProps) {
  const { t: tt } = useTranslation('WEB');

  const { tooltip, label, ...rest } = props;

  return (
    <Tooltip title={tooltip ?? tt('Click to learn more')}>
      <ClickableLabel iconName="InfoCircle" label={label ?? tt('Out of policy')} {...rest} />
    </Tooltip>
  );
}
